import { evaluateHand } from './evaluator.js';
import { RANKS } from './cards.js';

export const PERSONALITIES = [
  { id: 'mara', name: 'Mara Voss', title: 'The Reader', aggression: 0.34, bluff: 0.06, quote: 'Every hand leaves a footprint.' },
  { id: 'mateo', name: 'Mateo Cruz', title: 'The Drifter', aggression: 0.68, bluff: 0.17, quote: 'Fortune likes a moving target.' },
  { id: 'isaiah', name: 'Isaiah Reed', title: 'The Foreman', aggression: 0.49, bluff: 0.11, quote: 'Measure twice. Wager once.' },
  { id: 'mei', name: 'Dr. Mei Lin', title: 'The Physician', aggression: 0.42, bluff: 0.08, quote: 'A pulse tells on a liar.' },
  { id: 'finn', name: 'Finn Callahan', title: 'The Wireman', aggression: 0.74, bluff: 0.2, quote: 'Bad news travels. Good cards wait.' },
  { id: 'eli', name: 'Eli Tallgrass', title: 'The Rancher', aggression: 0.29, bluff: 0.05, quote: 'Patience outlasts weather.' }
];

function rankValue(card) {
  return RANKS.indexOf(card[0]) + 2;
}

export function chooseDiscards(cards) {
  const evaluation = evaluateHand(cards);
  const byRank = new Map();
  cards.forEach((card, index) => {
    const rank = card[0];
    if (!byRank.has(rank)) byRank.set(rank, []);
    byRank.get(rank).push(index);
  });
  if (evaluation.category >= 4 || evaluation.category === 6) return [];
  if (evaluation.category === 7) {
    const quad = [...byRank.values()].find(indices => indices.length === 4);
    return cards.map((_, index) => index).filter(index => !quad.includes(index));
  }
  if (evaluation.category === 3) {
    const trips = [...byRank.values()].find(indices => indices.length === 3);
    return cards.map((_, index) => index).filter(index => !trips.includes(index));
  }
  if (evaluation.category === 2) {
    const keep = [...byRank.values()].filter(indices => indices.length === 2).flat();
    return cards.map((_, index) => index).filter(index => !keep.includes(index));
  }
  if (evaluation.category === 1) {
    const pair = [...byRank.values()].find(indices => indices.length === 2);
    return cards.map((_, index) => index).filter(index => !pair.includes(index));
  }

  const suits = new Map();
  cards.forEach((card, index) => {
    if (!suits.has(card[1])) suits.set(card[1], []);
    suits.get(card[1]).push(index);
  });
  const fourFlush = [...suits.values()].find(indices => indices.length === 4);
  if (fourFlush) return cards.map((_, index) => index).filter(index => !fourFlush.includes(index));
  const high = cards.map((card, index) => ({ index, value: rankValue(card) })).filter(card => card.value >= 11).sort((a, b) => b.value - a.value).slice(0, 2);
  const keep = new Set(high.map(card => card.index));
  return cards.map((_, index) => index).filter(index => !keep.has(index)).slice(0, 3);
}

export function chooseAction({ seat, legal, phase, random = Math.random }) {
  if (legal.length === 1) return legal[0];
  const personality = PERSONALITIES[seat.aiIndex];
  const strength = evaluateHand(seat.cards).category / 8;
  const postDrawLift = phase === 'BET_POST' ? 0.08 : 0;
  const pressure = strength + personality.aggression * 0.3 + postDrawLift;
  const roll = random();
  const raise = legal.find(action => action.type === 'RAISE' || action.type === 'BET');
  const check = legal.find(action => action.type === 'CHECK');
  const call = legal.find(action => action.type === 'CALL');
  const fold = legal.find(action => action.type === 'FOLD');
  if (raise && (pressure > 0.55 || roll < personality.bluff)) return raise;
  if (check) return check;
  if (call && (strength >= 0.13 || roll < 0.25 + personality.aggression * 0.3)) return call;
  return fold || call || legal[0];
}
